import { USCurrency } from 'components/ReusableComponents/FormattedPrice'
import moment from 'moment'

import styles from './InvoiceSummaryCard.module.scss'

const InvoiceSummaryCard = ({ invoiceDetails }) => {
  const {
    billingAddress,
    subsidiaryName,
    generatedOn,
    issuedOn,
    previousBalance,
    paymentsAppliedSinceLastInvoice,
    balanceForward,
    invoiceAmount,
    totalAmountDueWithPreviousBalance,
    paymentDueDate,
    status,
    deliveredToName,
    subsidiaryInvoiceId
  } = invoiceDetails

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.invoiceId}>
          Invoice #{subsidiaryInvoiceId}
          {status === 'Paid' && <span className={styles.pill}>Paid</span>}
        </span>
        <span className={styles.invoiceDate}>
          {moment(issuedOn).format('YYYY') !== '0001'
            ? `Issued on ${moment(issuedOn).format('MMM DD, YYYY')}`
            : `Processing`}
        </span>
      </div>
      <div className={styles.content}>
        <div className={styles.addresses}>
          <div className={styles.address}>
            <p className={styles.addressTitle}>Invoice to</p>
            <p className={styles.addressName}>
              {deliveredToName
                ? deliveredToName.length > 24
                  ? null
                  : deliveredToName
                : '-'}
            </p>
            <p className={styles.addressItself}>{invoiceDetails.invoiceAddress}</p>
          </div>
          <div>
            <p className={styles.addressTitle}>Bill to</p>
            <p className={styles.addressName}>{subsidiaryName}</p>
            <p className={styles.addressItself}>{billingAddress}</p>
          </div>
        </div>
        <div className={styles.breakdown}>
          <div className={styles.summaryTableRow}>
            <div className={styles.summaryTableLabel}>Previous balance</div>
            <div className={styles.summaryTableValue}>
              <USCurrency>{previousBalance}</USCurrency>
            </div>
          </div>
          <div className={styles.summaryTableRow}>
            <div className={styles.summaryTableLabel}>Payments applied</div>
            <div className={styles.summaryTableValue}>
              -<USCurrency>{paymentsAppliedSinceLastInvoice}</USCurrency>
            </div>
          </div>
          <div className={styles.summaryTableRow}>
            <div className={styles.summaryTableLabel}>Balance forward</div>
            <div className={styles.summaryTableValue}>
              <USCurrency>{balanceForward}</USCurrency>
            </div>
          </div>
          <div className={styles.summaryTableRow}>
            <div className={styles.summaryTableLabel}>
              New charges ({moment(generatedOn).format('MMM YYYY')})
            </div>
            <div className={styles.summaryTableValue}>
              <USCurrency>{invoiceAmount}</USCurrency>
            </div>
          </div>
          <div className={styles.summaryTableRowHighlighted}>
            <div className={styles.summaryTableLabel}>
              Total Due by {moment(paymentDueDate).format('MMM DD, YYYY')}
            </div>
            <div className={styles.summaryTableValue}>
              <USCurrency withCode>{totalAmountDueWithPreviousBalance}</USCurrency>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceSummaryCard
